// ตรวจว่าพนักงานราชการ (แถวที่มี id_card จริง ไม่ใช่กรอบว่าง) ขาด "สัญญาจ้างเพิ่มเติม" ที่ยังมีผลอยู่หรือไม่
// ใช้สัญญาณจากวันที่สัญญาเป็นตัวตรวจแทนการพยายามสืบที่มาของการย้าย เพราะบางกรณีส่วนกลางประกาศผล
// โยกย้าย/สับเปลี่ยน/เกลี่ยอัตรา โดยไม่ผ่านระบบนี้เลย (ไม่มี record ต้นทางให้ตรวจสอบได้)
export function isContractGap(emp) {
  if (!emp || String(emp.id_card) === "0") return false;
  if (!emp.govem_contract) return true;
  if (!emp.last_contract_end) return true;
  return new Date(emp.last_contract_end) < new Date();
}
